import { useLazyQuery } from '@apollo/client';

import { Ticket } from 'app/shared/typings/tickets';

import { GET_TICKET } from './queries';

interface GetTicketParameters {
  id: number;
  eventAttendeeId: number;
}

interface GetTicketResponse {
  success: boolean;
  ticket?: Ticket;
}

export const GetTicketLazy = () => {
  return useLazyQuery<GetTicketResponse, GetTicketParameters>(GET_TICKET);
};
